import throwMessage from "../../utils/throwMessage";

function isEmpty(obj) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}

export const mongoDBRequest = async (url, method, data) => {
  const isOnline = typeof navigator !== 'undefined' ? navigator.onLine : true;
  if (!isOnline) {
    throwMessage("error", "Check Your Network Connection");
    return;
  }

  const TC_TOKEN_AUTH = localStorage.getItem("TC_TOKEN_AUTH");
  let user = localStorage.getItem("user");

  // Parse user only if it exists (for sign-in, user won't exist yet)
  const parsedUser = user ? JSON.parse(user) : null;
  const userId = parsedUser?._id;
  const role = parsedUser?.role;

  // Build URL with base query parameters (only if user is logged in)
  let urlWithParams = `${process.env.REACT_APP_API}/${url}`;
  
  if (userId && role) {
    const separator = urlWithParams.includes('?') ? '&' : '?';
    urlWithParams += `${separator}${new URLSearchParams({
      user_id: userId,
      role: role,
    })}`;
  }

  // For GET requests, add additional query parameters from data
  if (method === "GET" && data) {
    const separator = urlWithParams.includes('?') ? '&' : '?';
    const additionalParams = new URLSearchParams(data);
    urlWithParams += `${separator}${additionalParams}`;
  }

  const payload = method === "GET" ? undefined : data;
  
  return fetch(urlWithParams, {
    method: `${method}`,
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${TC_TOKEN_AUTH}`,
    },
    body: payload ? JSON.stringify(payload) : undefined,
  })
    .then((response) => {
      return response.json();
    })
    .catch((err) => {
      if (!isEmpty(err)) throwMessage("error","Database Error");
    });
};
